<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ mode === 'create' ? 'Create New Template' : 'Edit Template' }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button 
        (click)="onSubmit()" 
        [disabled]="form.invalid || submitting()"
        color="primary"
      >
        <strong>{{ mode === 'create' ? 'Create' : 'Save' }}</strong>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="form" *ngIf="form">
    <ion-list>
      
      <!-- Template Title Section -->
      <ion-item-divider color="light">
        <ion-label><strong>Template Information</strong></ion-label>
      </ion-item-divider>
      
<ion-item>
  <ion-label position="stacked">Template Title *</ion-label>


  
  <ion-input
    id="templateTitle"
    [formControl]="templateTitleControl"
    type="text"
    name="templateTitle"
    placeholder="Enter a unique template name"
    [class.ion-invalid]="templateTitleHasError"
    [class.ion-touched]="templateTitleControl.touched"
    [errorText]="templateTitleErrorMessage"
    (ionBlur)="onTemplateTitleBlur()"
  ></ion-input>

</ion-item>


      <!-- Job Details Section -->
      <ion-item-divider color="light">
        <ion-label><strong>Job Details</strong></ion-label>
      </ion-item-divider>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['subcontractor'] }}</ion-label>
        <ion-input formControlName="subcontractor" placeholder="Enter subcontractor name"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['jobName'] }}</ion-label>
        <ion-input formControlName="jobName" placeholder="Enter job name"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['jobNumber'] }}</ion-label>
        <ion-input formControlName="jobNumber" placeholder="Enter job number"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['taskDescription'] }}</ion-label>
        <ion-textarea 
          formControlName="taskDescription" 
          placeholder="Describe the task to be performed"
          rows="3"
        ></ion-textarea>
      </ion-item>

      <!-- Job Steps & Hazard Analysis Section -->
      <ion-item-divider color="light">
        <ion-label><strong>Job Steps & Hazard Analysis</strong></ion-label>
      </ion-item-divider>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['jobSteps'] }}</ion-label>
        <ion-textarea 
          formControlName="jobSteps" 
          placeholder="Enter all job steps"
          rows="4"
        ></ion-textarea>
      </ion-item>

      <!-- Hazard 1 (always visible) -->
      <ion-item-divider color="medium">
        <ion-label>Hazard & Control #1</ion-label>
      </ion-item-divider>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['identifiedHazard1'] }}</ion-label>
        <ion-input 
          formControlName="identifiedHazard1" 
          placeholder="Enter first identified hazard"
        ></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['hazardControl1'] }}</ion-label>
        <ion-input 
          formControlName="hazardControl1" 
          placeholder="Enter control method for hazard"
        ></ion-input>
      </ion-item>

      <!-- Hazard 2 -->
      <ng-container *ngIf="showHazardControlIndex[1]">
        <ion-item-divider color="medium">
          <ion-label>Hazard & Control #2</ion-label>
        </ion-item-divider>

        <ion-item>
          <ion-label position="stacked">{{ fieldMappings['identifiedHazard2'] }}</ion-label>
          <ion-input formControlName="identifiedHazard2" placeholder="Enter second identified hazard"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">{{ fieldMappings['hazardControl2'] }}</ion-label>
          <ion-input formControlName="hazardControl2" placeholder="Enter control method for hazard"></ion-input>
        </ion-item>
      </ng-container>

      <!-- Hazard 3 -->
      <ng-container *ngIf="showHazardControlIndex[2]">
        <ion-item-divider color="medium">
          <ion-label>Hazard & Control #3</ion-label>
        </ion-item-divider>

        <ion-item>
          <ion-label position="stacked">{{ fieldMappings['identifiedHazard3'] }}</ion-label>
          <ion-input formControlName="identifiedHazard3" placeholder="Enter third identified hazard"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">{{ fieldMappings['hazardControl3'] }}</ion-label>
          <ion-input formControlName="hazardControl3" placeholder="Enter control method for hazard"></ion-input>
        </ion-item>
      </ng-container>

      <!-- Hazard 4 -->
      <ng-container *ngIf="showHazardControlIndex[3]">
        <ion-item-divider color="medium">
          <ion-label>Hazard & Control #4</ion-label>
        </ion-item-divider>

        <ion-item>
          <ion-label position="stacked">{{ fieldMappings['identifiedHazard4'] }}</ion-label>
          <ion-input formControlName="identifiedHazard4" placeholder="Enter fourth identified hazard"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">{{ fieldMappings['hazardControl4'] }}</ion-label>
          <ion-input formControlName="hazardControl4" placeholder="Enter control method for hazard"></ion-input>
        </ion-item>
      </ng-container>

      <!-- Hazard 5 -->
      <ng-container *ngIf="showHazardControlIndex[4]">
        <ion-item-divider color="medium">
          <ion-label>Hazard & Control #5</ion-label>
        </ion-item-divider>

        <ion-item>
          <ion-label position="stacked">{{ fieldMappings['identifiedHazard5'] }}</ion-label>
          <ion-input formControlName="identifiedHazard5" placeholder="Enter fifth identified hazard"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">{{ fieldMappings['hazardControl5'] }}</ion-label>
          <ion-input formControlName="hazardControl5" placeholder="Enter control method for hazard"></ion-input>
        </ion-item>
      </ng-container>

      <!-- Hazard 6 -->
      <ng-container *ngIf="showHazardControlIndex[5]">
        <ion-item-divider color="medium">
          <ion-label>Hazard & Control #6</ion-label>
        </ion-item-divider>

        <ion-item>
          <ion-label position="stacked">{{ fieldMappings['identifiedHazard6'] }}</ion-label>
          <ion-input formControlName="identifiedHazard6" placeholder="Enter sixth identified hazard"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">{{ fieldMappings['hazardControl6'] }}</ion-label>
          <ion-input formControlName="hazardControl6" placeholder="Enter control method for hazard"></ion-input>
        </ion-item>
      </ng-container>

      <!-- Hazard 7 -->
      <ng-container *ngIf="showHazardControlIndex[6]">
        <ion-item-divider color="medium">
          <ion-label>Hazard & Control #7</ion-label>
        </ion-item-divider>

        <ion-item>
          <ion-label position="stacked">{{ fieldMappings['identifiedHazard7'] }}</ion-label>
          <ion-input formControlName="identifiedHazard7" placeholder="Enter seventh identified hazard"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">{{ fieldMappings['hazardControl7'] }}</ion-label>
          <ion-input formControlName="hazardControl7" placeholder="Enter control method for hazard"></ion-input>
        </ion-item>
      </ng-container>

      <!-- Add Hazard Control Button -->
      <ion-item lines="none">
        <ion-button 
          (click)="addHazardControl()" 
          fill="clear"
          [disabled]="!showAddHazardControlButton"
        >
          <ion-icon name="add-circle-outline" slot="start"></ion-icon>
          {{ showAddHazardControlButton ? 'Add Another Hazard' : 'Maximum Reached' }}
        </ion-button>
      </ion-item>

              <!--Hazard Assessment Section -->
      <ion-item-divider color="light">
        <ion-label><strong>Hazard Assessment</strong></ion-label>
      </ion-item-divider>


      
<ion-item>
  <ion-label position="stacked">{{ fieldMappings['fireExplosionToxicHazard'] }}</ion-label>
  <ion-radio-group formControlName="fireExplosionToxicHazard">
    <ion-item lines="none">
      <ion-label>Yes</ion-label>
      <ion-radio slot="start" value="Yes"></ion-radio>
    </ion-item>
    <ion-item lines="none">
      <ion-label>No</ion-label>
      <ion-radio slot="start" value="No"></ion-radio>
    </ion-item>
  </ion-radio-group>
</ion-item>

<ion-item>
  <ion-label position="stacked">{{ fieldMappings['sdsReviewRequired'] }}</ion-label>
  <ion-radio-group formControlName="sdsReviewRequired">
    <ion-item lines="none">
      <ion-label>Yes</ion-label>
      <ion-radio slot="start" value="Yes"></ion-radio>
    </ion-item>
    <ion-item lines="none">
      <ion-label>No</ion-label>
      <ion-radio slot="start" value="No"></ion-radio>
    </ion-item>
  </ion-radio-group>
</ion-item>


          <!-- Required Permits Section -->
      <ion-item-divider color="light">
        <ion-label><strong>Required Permits</strong></ion-label>
      </ion-item-divider>

      <ion-item *ngFor="let checkbox of requiredPermitsCheckboxes">
        <ion-checkbox [formControlName]="checkbox.name" labelPlacement="end">
          {{ checkbox.label }}
        </ion-checkbox>
      </ion-item>

      <ion-item *ngIf="form.get('otherPermit')?.value">
        <ion-label position="stacked">{{ fieldMappings['otherPermitDescription'] }}</ion-label>
        <ion-input 
          formControlName="otherPermitDescription" 
          placeholder="Describe other permit requirements"
        ></ion-input>
      </ion-item>

    

      <!-- Hazard Conditions Section -->
      <ion-item-divider color="light">
        <ion-label><strong>Hazard Conditions</strong></ion-label>
      </ion-item-divider>

      <ion-item *ngFor="let checkbox of hazardConditionsCheckboxes">
        <ion-checkbox [formControlName]="checkbox.name" labelPlacement="end">
          {{ checkbox.label }}
        </ion-checkbox>
      </ion-item>

      <ion-item *ngIf="form.get('otherHazardConditions')?.value">
        <ion-label position="stacked">{{ fieldMappings['otherConditions'] }}</ion-label>
        <ion-input 
          formControlName="otherConditions" 
          placeholder="Describe other conditions"
        ></ion-input>
      </ion-item>

      <!-- Control Methods Section -->
      <ion-item-divider color="light">
        <ion-label><strong>Control Methods</strong></ion-label>
      </ion-item-divider>

      <ion-item *ngFor="let checkbox of controlMethodsCheckboxes">
        <ion-checkbox [formControlName]="checkbox.name" labelPlacement="end">
          {{ checkbox.label }}
        </ion-checkbox>
      </ion-item>

      <ion-item *ngIf="form.get('otherControlMethods')?.value">
        <ion-label position="stacked">{{ fieldMappings['otherControlMethod'] }}</ion-label>
        <ion-input 
          formControlName="otherControlMethod" 
          placeholder="Describe other control methods"
        ></ion-input>
      </ion-item>

      <!-- Crew Member Information Section -->
      <ion-item-divider color="light">
        <ion-label><strong>Crew Member Information</strong></ion-label>
      </ion-item-divider>

      <ion-item-divider color="medium">
        <ion-label>Foreperson</ion-label>
      </ion-item-divider>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['forepersonFirstName'] }}</ion-label>
        <ion-input formControlName="forepersonFirstName" placeholder="Enter first name"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['forepersonLastName'] }}</ion-label>
        <ion-input formControlName="forepersonLastName" placeholder="Enter last name"></ion-input>
      </ion-item>

      <ion-item-divider color="medium">
        <ion-label>Crew Member 1</ion-label>
      </ion-item-divider>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['crewMember1FirstName'] }}</ion-label>
        <ion-input formControlName="crewMember1FirstName" placeholder="Enter first name"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['crewMember1LastName'] }}</ion-label>
        <ion-input formControlName="crewMember1LastName" placeholder="Enter last name"></ion-input>
      </ion-item>

      <ion-item-divider color="medium">
        <ion-label>Crew Member 2</ion-label>
      </ion-item-divider>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['crewMember2FirstName'] }}</ion-label>
        <ion-input formControlName="crewMember2FirstName" placeholder="Enter first name (optional)"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['crewMember2LastName'] }}</ion-label>
        <ion-input formControlName="crewMember2LastName" placeholder="Enter last name (optional)"></ion-input>
      </ion-item>

      <ion-item-divider color="medium">
        <ion-label>Crew Member 3</ion-label>
      </ion-item-divider>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['crewMember3FirstName'] }}</ion-label>
        <ion-input formControlName="crewMember3FirstName" placeholder="Enter first name (optional)"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['crewMember3LastName'] }}</ion-label>
        <ion-input formControlName="crewMember3LastName" placeholder="Enter last name (optional)"></ion-input>
      </ion-item>

      <!-- Other Notes -->
      <ion-item-divider color="light">
        <ion-label><strong>Additional Notes</strong></ion-label>
      </ion-item-divider>

      <ion-item>
        <ion-label position="stacked">{{ fieldMappings['otherNotes'] }}</ion-label>
        <ion-textarea 
          formControlName="otherNotes" 
          placeholder="Enter other notes (optional)"
          rows="3"
        ></ion-textarea>
      </ion-item>

    </ion-list>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()" fill="outline">
        Cancel
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button 
        (click)="onSubmit()" 
        [disabled]="form.invalid || submitting()"
        color="primary"
        fill="solid"
      >
        <ion-icon name="checkmark-outline" slot="start"></ion-icon>
        {{ mode === 'create' ? 'Create Template' : 'Save Changes' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>